import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPreMediaList, setPostMediaList } from "@/store/media/media.slice";
import { DRIVE_TAB } from "@/utils/constants/tabConstants";
import {
  Button,
  Modal,
  GeneralPlayer,
  CanvasOverlayControls,
  OverlayEditingModal,
} from "..";
import { secondsToHms } from "../../utils";
import { trackEvent, getTrackUserContext } from "@/utils/analytics";
import { getThumbnailUrlUtil } from "@/utils/mediaUtils";
import { getUqinueTeamFromPermission } from "@/utils/mediautils/CommonFunctions";
import { PresetListModel } from "@/database";
interface VideoTrimmerProps {
  isOpen: boolean;
  onClose: () => void;
  media: any;
  onTrimComplete: (trimmedMedia: any) => void;
  trimMedia: (data: any) => Promise<any>;
  updateModal: any; // Accept any type to avoid circular dependency issues
  presetList?: any[];
  preMediaList?: any[];
  postMediaList?: any[];
  getListMedia?: (params: any) => void;
  getSearchedListMedia?: (params: any) => void;
  getPresetList?: (params: PresetListModel) => void;
  getMedia?: (params: any) => void;
  currentTab?: string;
  callRegisterMediaOnCms?: any;
  isPreset?: boolean;
  ImageUpload?: any;
  currentMedia?: any;
  mediaList?: any[];
  handleSetConvasOverlay?: (params: any) => void;
  PresetHeaderForm?: any;
  presetData?: any;
  isEdit?: boolean;
  OnCloseModal?: any;
  isPreview?: boolean;
  readOnlyMode?: boolean;
  isShowModal?: boolean;
  setMediaDuration?: (duration: number) => void;
  isChopperFlow?: boolean;
}

const VideoTrimmer: React.FC<VideoTrimmerProps> = ({
  isOpen,
  onClose,
  media,
  onTrimComplete,
  trimMedia,
  updateModal,
  presetList = [],
  preMediaList = [],
  postMediaList = [],
  getSearchedListMedia,
  getPresetList,
  getMedia,
  currentTab,
  callRegisterMediaOnCms,
  isPreset,
  ImageUpload,
  currentMedia,
  handleSetConvasOverlay,
  presetData,
  isEdit,
  isPreview = false,
  isShowModal = true,
  readOnlyMode = false,
  setMediaDuration,
  isChopperFlow = false,
}) => {
  const dispatch = useDispatch();

  // Trimmer state
  const [startTrim, setStartTrim] = useState(0);
  const [endTrim, setEndTrim] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentPlayerTime, setCurrentPlayerTime] = useState(0);
  const [playerKey, setPlayerKey] = useState(0);
  const [segments, setSegments] = useState([]);
  const [capturedCanvas, setCapturedCanvas] =
    useState<HTMLCanvasElement | null>(null);
  const [totalDuration, setTotalDuration] = useState(0);

  const videoDims =
    media.meta?.width && media.meta?.height
      ? { width: media.meta.width, height: media.meta.height }
      : undefined;

  // Preset state
  const [presetId, setPresetId] = useState<string | null>(null);
  const [presetInfo, setPresetInfo] = useState<any>(presetData || null);
  const [preMedia, setPreMedia] = useState<any>(null);
  const [postMedia, setPostMedia] = useState<any>(null);
  const [preRollMedia, setPreRollMedia] = useState<any>(null);
  const [postRollMedia, setPostRollMedia] = useState<any>(null);
  const [isPreEdit, setIsPreEdit] = useState(false);
  const [isPostEdit, setIsPostEdit] = useState(false);
  const [isGetListMedia, setIsGetListMedia] = useState(false);
  const [localPreMediaList, setLocalPreMediaList] =
    useState<any[]>(preMediaList);
  const [localPostMediaList, setLocalPostMediaList] =
    useState<any[]>(postMediaList);

  useEffect(() => {
    setLocalPreMediaList(preMediaList);
  }, [preMediaList]);
  useEffect(() => {
    setLocalPostMediaList(postMediaList);
  }, [postMediaList]);

  const trimmerLocation =
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/discover")
      ? "discover"
      : "content";

  // Canvas overlay state
  const [canvasOverlay, setCanvasOverlay] = useState({
    showCanvasOverlay: false,
    textOverlays: [] as Array<{
      id: string;
      text: string;
      fontSize: number;
      fontColor: string;
      backgroundColor: string;
      position: { x: number; y: number };
      visible: boolean;
      isBold?: boolean;
      isItalic?: boolean;
      isUnderline?: boolean;
      padding?: number;
      rotation?: number;
      opacity?: number;
      fontFamily?: string;
    }>,
    logoOverlays: [] as Array<{
      id: string;
      url: string;
      position: { x: number; y: number };
      size: { width: number; height: number };
      visible: boolean;
      opacity?: number;
      rotation?: number;
    }>,
    slateOverlays: [] as Array<{
      id: string;
      url: string;
      position: { x: number; y: number };
      size: { width: number; height: number };
      visible: boolean;
      isSlate: boolean;
      duration?: number;
      autoHide?: boolean;
      isPreRoll?: boolean;
      isPostRoll?: boolean;
    }>,
  });

  // Modal states
  const [showTextModal, setShowTextModal] = useState(false);
  const [showLogoModal, setShowLogoModal] = useState(false);
  const [selectedTextOverlayId, setSelectedTextOverlayId] = useState<
    string | undefined
  >(undefined);
  const [selectedLogoOverlayId, setSelectedLogoOverlayId] = useState<
    string | undefined
  >(undefined);
  const closeLogoSlidersRef = React.useRef<(() => void) | null>(null);

  // Text editing state
  const [textEditingState, setTextEditingState] = useState({
    isEditing: false,
    textOverlayId: undefined as string | undefined,
    text: "",
    fontSize: 24,
    fontColor: "#ffffff",
    backgroundColor: "#000000",
    position: { x: 0, y: 0 },
    isBold: false,
    isItalic: false,
    isUnderline: false,
    padding: 0,
    rotation: 0,
    opacity: 1.0,
    fontFamily: "Arial",
  });

  // Logo editing state
  const [logoEditingState, setLogoEditingState] = useState({
    isEditing: false,
    logoOverlayId: undefined as string | undefined,
    url: "",
    position: { x: 0, y: 0 },
    size: { width: 200, height: 200 },
    opacity: 1.0,
    aspectRatio: 1.0,
    rotation: 0,
  });
  const [maintainAspectRatio, setMaintainAspectRatio] = useState(false);

  const [isTrimLoading, setIsTrimLoading] = useState(false);

  useEffect(() => {
    if (media?.meta?.duration && media.meta.duration > 0) {
      const videoDuration = media.meta.duration;
      setDuration(videoDuration);
      setMediaDuration && setMediaDuration(videoDuration);
      setEndTrim(videoDuration);
    } else {
      setDuration(0);
      setEndTrim(0);
    }
    setPlayerKey((prev) => prev + 1);
  }, [media?.meta?.duration]);

  useEffect(() => {
    setMediaDuration && setMediaDuration(duration);
  }, [duration, setMediaDuration]);

  // Reset states when modal opens
  useEffect(() => {
    if (isOpen) {
      const initialDuration = media?.meta?.duration || 0;
      setStartTrim(0);
      setEndTrim(initialDuration);
      setDuration(initialDuration);
      setMediaDuration && setMediaDuration(initialDuration);
      setCurrentPlayerTime(0);

      if (!isEdit) {
        setCanvasOverlay({
          showCanvasOverlay: true,
          textOverlays: [],
          logoOverlays: [],
          slateOverlays: [],
        });
      }

      // Reset selected overlays
      setSelectedTextOverlayId(undefined);
      setSelectedLogoOverlayId(undefined);

      // Reset pre/CLOSE STATE
      setPreRollMedia(null);
      setPostRollMedia(null);
      setIsTrimLoading(false);
      // Clear stale slate search results from a previous media's trimmer session
      dispatch(setPreMediaList({ data: { list: [], count: 0 } }));
      dispatch(setPostMediaList({ data: { list: [], count: 0 } }));
      setLocalPreMediaList([]);
      setLocalPostMediaList([]);
    } else {
      dispatch(setPreMediaList({ data: { list: [], count: 0 } }));
      dispatch(setPostMediaList({ data: { list: [], count: 0 } }));
    }
  }, [isOpen, media?.meta?.duration, isEdit]);

  // Handle preset ID change
  const handlePresetId = (presetId: any) => {
    setPresetId(presetId);
    if (presetList && presetId) {
      const selectedPreset = presetList.find(
        (preset: any) => preset.id === presetId
      );
      if (selectedPreset) {
        setPresetInfo(selectedPreset);
      }
    }
  };

  useEffect(() => {
    if (isPreset) {
      if (handleSetConvasOverlay) {
        handleSetConvasOverlay(canvasOverlay);
      }
    }
  }, [canvasOverlay]);

  useEffect(() => {
    if (!presetInfo) return;
    if (presetInfo?.branding) {
      setCanvasOverlay({
        showCanvasOverlay: true,
        textOverlays: presetInfo.branding[0].textOverlays,
        logoOverlays: presetInfo.branding[0].logoOverlays,
        slateOverlays: [],
      });
    }
  }, [presetInfo]);

  useEffect(() => {
    if (presetId && presetList) {
      const selectedPreset = presetList.find(
        (preset: any) => preset.id === presetId
      );
      if (selectedPreset && selectedPreset !== presetInfo) {
        setPresetInfo(selectedPreset);
      }
    }
  }, [presetId, presetList]);

  useEffect(() => {
    if (!presetInfo) return;
    if (presetInfo?.branding) {
      const preMediaId = presetInfo.branding[0].pre_slate;

      if (getSearchedListMedia) {
        getSearchedListMedia({
          stitle: preMediaId,
          key: "pre",
          asset_type: "slates",
          orientation: media?.orientation,
          is_foreign_keys: false,
        });
      }
      setIsGetListMedia(true);
    }
  }, [presetInfo]);

  useEffect(() => {
    if (!presetInfo) return;
    if (presetInfo?.branding) {
      const postMediaId = presetInfo.branding[0].post_slate;

      if (getSearchedListMedia) {
        getSearchedListMedia({
          stitle: postMediaId,
          key: "post",
          asset_type: "slates",
          orientation: media?.orientation,
          is_foreign_keys: false,
        });
      }
      setIsGetListMedia(true);
    }
  }, [presetInfo]);

  useEffect(() => {
    if (!presetInfo) return;

    if (isGetListMedia) {
      // Get the IDs from presetData
      const preMediaId = presetInfo?.branding?.[0]?.pre_slate;
      const postMediaId = presetInfo?.branding?.[0]?.post_slate;
      // Find the correct media items by ID
      const preMediaItem: any = preMediaList.find(
        (media) => media.id === preMediaId
      );
      const postMediaItem: any = postMediaList.find(
        (media) => media.id === postMediaId
      );

      if (preMediaItem) {
        const temppreMediaItem = {
          label: preMediaItem?.id,
          image:
            preMediaItem?.image ||
            getThumbnailUrlUtil({
              media: preMediaItem,
              id: preMediaItem?.images?.thumb,
              source: preMediaItem?.source,
            }),
          duration: preMediaItem?.duration || preMediaItem?.meta?.duration || 5,
          value: preMediaItem?.title,
          thumb: true,
          uploadedAt: preMediaItem?.uploadedAt,
        };
        setPreRollMedia(temppreMediaItem);
      }
      if (postMediaItem) {
        const temppostMediaItem = {
          label: postMediaItem?.id,
          image:
            postMediaItem?.image ||
            getThumbnailUrlUtil({
              media: postMediaItem,
              id: postMediaItem?.images?.thumb,
              source: postMediaItem?.source,
            }),
          duration:
            postMediaItem?.duration || postMediaItem?.meta?.duration || 5,
          value: postMediaItem?.title,
          thumb: true,
          uploadedAt: postMediaItem?.uploadedAt,
        };
        setPostRollMedia(temppostMediaItem);
      }
      setCanvasOverlay((prev) => {
        let updatedSlateOverlays = [...prev.slateOverlays];
        if (preMediaItem) {
          setPreMedia(preMediaItem);

          const newPreSlateOverlay = {
            id: preMediaItem.id,
            url:
              preMediaItem.image ||
              getThumbnailUrlUtil({
                media: preMediaItem,
                id:
                  preMediaItem?.images?.thumb || preMediaItem?.images?.portrait,
                source: preMediaItem?.source,
              }),
            position: { x: 50, y: 50 },
            size: { width: 200, height: 200 },
            visible: true,
            isSlate: true,
            duration: preMediaItem.duration || preMediaItem.meta?.duration || 5,
            autoHide: true,
            isPreRoll: true,
          };
          // Remove existing pre-roll slate and add new one
          updatedSlateOverlays = updatedSlateOverlays.filter(
            (slate) => !slate.isPreRoll
          );
          updatedSlateOverlays.push(newPreSlateOverlay);
        } else {
          // Remove pre-roll slate
          updatedSlateOverlays = updatedSlateOverlays.filter(
            (slate) => !slate.isPreRoll
          );
        }

        if (postMediaItem) {
          setPostMedia(postMediaItem);
          const newPostSlateOverlay = {
            id: postMediaItem.id,
            url:
              postMediaItem.image ||
              getThumbnailUrlUtil({
                media: postMediaItem,
                id:
                  postMediaItem?.images?.thumb ||
                  postMediaItem?.images?.portrait,
                source: postMediaItem?.source,
              }),
            position: { x: 50, y: 50 },
            size: { width: 200, height: 200 },
            visible: true,
            isSlate: true,
            duration:
              postMediaItem.duration || postMediaItem.meta?.duration || 5,
            autoHide: true,
            isPostRoll: true,
          };
          // Remove existing post-roll slate and add new one
          updatedSlateOverlays = updatedSlateOverlays.filter(
            (slate) => !slate.isPostRoll
          );
          updatedSlateOverlays.push(newPostSlateOverlay);
        } else {
          // Remove post-roll slate
          updatedSlateOverlays = updatedSlateOverlays.filter(
            (slate) => !slate.isPostRoll
          );
        }

        return {
          ...prev,
          slateOverlays: updatedSlateOverlays,
        };
      });

      // Reset edit states
      setIsPreEdit(false);
      setIsPostEdit(false);
      setIsGetListMedia(false);
    }
  }, [preMediaList, postMediaList, presetInfo]);

  // Get total duration
  const getTotalDuration = (totalDuration: number) => {
    setTotalDuration(totalDuration);
  };

  // Handle high res capture
  const handleHighResCapture = (canvas: HTMLCanvasElement) => {
    setCapturedCanvas(canvas);
  };
  const triggerCanvasCapture = () => {
    setCanvasOverlay((prev) => ({ ...prev, showCanvasOverlay: true }));
  };

  useEffect(() => {
    const hasOverlays =
      canvasOverlay.textOverlays.length > 0 ||
      canvasOverlay.logoOverlays.length > 0 ||
      canvasOverlay.slateOverlays.length > 0;

    if (hasOverlays && !capturedCanvas) {
      const timer = setTimeout(() => {
        setCanvasOverlay((prev) => ({ ...prev, showCanvasOverlay: true }));
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [
    canvasOverlay.textOverlays.length,
    canvasOverlay.logoOverlays.length,
    canvasOverlay.slateOverlays.length,
    capturedCanvas,
  ]);

  useEffect(() => {
    if (canvasOverlay.showCanvasOverlay && !capturedCanvas) {
      const hasOverlays =
        canvasOverlay.textOverlays.length > 0 ||
        canvasOverlay.logoOverlays.length > 0 ||
        canvasOverlay.slateOverlays.length > 0;

      if (hasOverlays) {
        const timer = setTimeout(() => {
          setCanvasOverlay((prev) => ({ ...prev }));
        }, 1500);

        return () => clearTimeout(timer);
      }
    }
  }, [
    canvasOverlay.showCanvasOverlay,
    capturedCanvas,
    canvasOverlay.textOverlays,
    canvasOverlay.logoOverlays,
    canvasOverlay.slateOverlays,
  ]);

  // Handle download trimmed image
  const handleDownloadTrimmedImage = async (blobURL: string) => {
    const a = document.createElement("a");
    a.href = blobURL;
    a.download = `${media.title}-trimmed.png`;
    a.click();
  };

  const handleCreatePreset = () => {
    const event = new CustomEvent("createMetaPreset");
    window.dispatchEvent(event);
  };

  // Handle trim complete
  const handleTrimComplete = async (isDownload: boolean) => {
    if (isPreview) {
      setIsTrimLoading(false);
      onClose();
      return;
    }
    if (isPreset) {
      setIsTrimLoading(false);
      handleCreatePreset();
      return;
    }
    trackEvent("browse", {
      category: "trimmer",
      entity: "applied",
      action: "click",
      location: trimmerLocation,
      ...getTrackUserContext(),
    });
    setIsTrimLoading(true);

    try {
      let tempCanvas = capturedCanvas;
      if (!tempCanvas) {
        for (let attempt = 1; attempt <= 3; attempt++) {
          triggerCanvasCapture();
          await new Promise((resolve) => setTimeout(resolve, 1000 * attempt));
          tempCanvas = capturedCanvas;

          if (tempCanvas) {
            break;
          }

          if (attempt < 3) {
            setCanvasOverlay((prev) => ({ ...prev }));
          }
        }
      }

      if (!tempCanvas) {
        console.error("Failed to capture canvas after multiple attempts");
        setIsTrimLoading(false);
        return;
      }
      const base64Image = tempCanvas.toDataURL("image/png");
      const blob = await fetch(base64Image).then((res) => res.blob());
      const blobURL = URL.createObjectURL(blob);

      if (!isDownload) {
        setIsTrimLoading(false);
        handleDownloadTrimmedImage(blobURL);
        return;
      }

      const thumbnailData: {
        damid: string;
        media: string;
        overlay: string;
        timestamp: number;
        trim: any[];
        post?: string;
        pre?: string;
        fid?: string;
        source?: string;
        asset_type?: string;
      } = {
        damid: media.damid,
        media: media.id,
        overlay: base64Image,
        timestamp: Date.now(),
        trim: segments,
        post: postRollMedia?.label,
        pre: preRollMedia?.label,
        fid: `${media.id}-${Date.now().toString()}`,
        ...(isChopperFlow
          ? { source: "chopper", asset_type: media?.asset_type }
          : {}),
      };

      const trimmedMedia = await trimMedia(thumbnailData);

      if (trimmedMedia && trimmedMedia.id) {
        handleReset();
        setIsTrimLoading(false);
        onClose();
        onTrimComplete(trimmedMedia);
        if (getMedia) {
          getMedia({ id: trimmedMedia.id });
        }
      }
    } catch (error) {
      console.error("Error capturing high-res canvas on Apply Trim:", error);
    } finally {
      setIsTrimLoading(false);
    }
  };

  // Handle start/end trim change
  const handleStartEndTrimChange = (start: number, end: number) => {
    setStartTrim(start);
    setEndTrim(end);
    setDuration(end - start);
    setMediaDuration && setMediaDuration(end - start);
  };

  // Handle time update
  const handleTimeUpdate = (time: number) => {
    setCurrentPlayerTime(time);
  };

  // Handle segments change
  const handleSegmentsChange = (newSegments: any) => {
    setSegments(newSegments);
  };

  // Handle canvas overlay change
  const handleCanvasOverlayChange = (overlayData: any) => {
    setCanvasOverlay((prev) => ({
      ...prev,
      textOverlays: overlayData.textOverlays,
      logoOverlays: overlayData.logoOverlays,
      slateOverlays:
        overlayData.slateOverlays !== undefined
          ? overlayData.slateOverlays
          : prev.slateOverlays,
    }));
  };

  // Handle text overlays change
  const handleTextOverlaysChange = (textOverlays: any[]) => {
    setCanvasOverlay((prev) => {
      const prevLength = prev.textOverlays?.length ?? 0;
      if (textOverlays.length > prevLength) {
        trackEvent("browse", {
          category: "trimmer",
          entity: "text bar",
          action: "apply",
          location: trimmerLocation,
          ...getTrackUserContext(),
        });
      }
      return {
        ...prev,
        textOverlays: textOverlays,
      };
    });
  };

  // Handle logo overlays change
  const handleLogoOverlaysChange = (logoOverlays: any[]) => {
    setCanvasOverlay((prev) => {
      const prevLength = prev.logoOverlays?.length ?? 0;
      if (logoOverlays.length > prevLength) {
        trackEvent("browse", {
          category: "trimmer",
          entity: "logo",
          action: "apply",
          location: trimmerLocation,
          ...getTrackUserContext(),
        });
      }
      return {
        ...prev,
        logoOverlays: logoOverlays,
      };
    });
  };

  // Handle slate overlays change
  const handleSlateOverlaysChange = (slateOverlays: any[]) => {
    setCanvasOverlay((prev) => ({
      ...prev,
      slateOverlays: slateOverlays,
    }));

    // Sync pre-roll and post-roll media state when slates are removed
    const hasPreRollSlate = slateOverlays.some(
      (slate) => slate.isPreRoll && slate.visible
    );
    const hasPostRollSlate = slateOverlays.some(
      (slate) => slate.isPostRoll && slate.visible
    );

    if (!hasPreRollSlate && preRollMedia) {
      setPreRollMedia(null);
    }
    if (!hasPostRollSlate && postRollMedia) {
      setPostRollMedia(null);
    }
  };

  // Handle canvas toggle
  const handleCanvasToggle = () => {
    setCanvasOverlay((prev) => ({
      ...prev,
      showCanvasOverlay: !prev.showCanvasOverlay,
    }));
  };
  // Handle logo upload
  const handleLogoUpload = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const url = e.target?.result as string;
      const img = new Image();
      img.onload = () => {
        const originalWidth = img.width > 0 ? img.width : 200;
        const originalHeight = img.height > 0 ? img.height : 200;
        const aspectRatio =
          originalWidth > 0 && originalHeight > 0
            ? originalWidth / originalHeight
            : 1.0;
        const MAX_SIZE = 300;
        let logoWidth = originalWidth;
        let logoHeight = originalHeight;

        if (logoWidth > MAX_SIZE || logoHeight > MAX_SIZE) {
          const scale = Math.min(MAX_SIZE / logoWidth, MAX_SIZE / logoHeight);
          logoWidth = logoWidth * scale;
          logoHeight = logoHeight * scale;
        }

        const newLogoOverlay = {
          id: `logo-${Date.now()}`,
          url: url,
          position: { x: 50, y: 50 },
          size: { width: logoWidth, height: logoHeight },
          visible: true,
          opacity: 1.0,
          rotation: 0,
          aspectRatio: aspectRatio,
        };
        handleLogoOverlaysChange([
          ...canvasOverlay.logoOverlays,
          newLogoOverlay,
        ]);
      };
      img.onerror = () => {
        const fallbackSize = 200;
        const newLogoOverlay = {
          id: `logo-${Date.now()}`,
          url: url,
          position: { x: 50, y: 50 },
          size: { width: fallbackSize, height: fallbackSize },
          visible: true,
          opacity: 1.0,
          rotation: 0,
          aspectRatio: 1.0,
        };
        handleLogoOverlaysChange([
          ...canvasOverlay.logoOverlays,
          newLogoOverlay,
        ]);
      };
      img.src = url;
    };
    reader.readAsDataURL(file);
  };

  // Handle reset - clean up all state
  const handleReset = () => {
    const currentDuration = media?.meta?.duration || 0;
    setStartTrim(0);
    setEndTrim(currentDuration);
    setDuration(currentDuration);
    setMediaDuration && setMediaDuration(currentDuration);
    setCurrentPlayerTime(0);
    setPlayerKey((prev) => prev + 1);

    // Reset overlay state
    setCanvasOverlay({
      showCanvasOverlay: true, // Keep canvas overlay enabled
      textOverlays: [],
      logoOverlays: [],
      slateOverlays: [],
    });

    // Reset selected overlays
    setSelectedTextOverlayId(undefined);
    setSelectedLogoOverlayId(undefined);

    // Reset pre-roll and post-roll state
    setPreRollMedia(null);
    setPostRollMedia(null);

    // Reset preset data
    setPresetId(null);
    setPresetInfo(null);
    setPreMedia(null);
    setPostMedia(null);

    // Reset segments
    setSegments([]);

    // Reset captured canvas
    setCapturedCanvas(null);

    // Reset total duration
    setTotalDuration(0);
    setIsTrimLoading(false);
  };

  // Handle text overlay select
  const handleTextOverlaySelect = (textOverlayId: string) => {
    setSelectedTextOverlayId(textOverlayId);
    setSelectedLogoOverlayId(undefined); // Clear logo selection when text is selected

    const selectedOverlay = canvasOverlay.textOverlays.find(
      (overlay) => overlay.id === textOverlayId
    );
    if (selectedOverlay) {
      const newTextEditingState = {
        isEditing: true,
        textOverlayId: selectedOverlay.id,
        text: selectedOverlay.text,
        fontSize: selectedOverlay.fontSize,
        fontColor: selectedOverlay.fontColor,
        backgroundColor: selectedOverlay.backgroundColor,
        position: selectedOverlay.position,
        isBold: selectedOverlay.isBold || false,
        isItalic: selectedOverlay.isItalic || false,
        isUnderline: selectedOverlay.isUnderline || false,
        padding: selectedOverlay.padding || 0,
        rotation: selectedOverlay.rotation || 0,
        opacity: selectedOverlay.opacity || 1.0,
        fontFamily: selectedOverlay.fontFamily || "Arial",
      };

      openModalWithDelay("text", () => {
        setTextEditingState(newTextEditingState);
        setShowTextModal(true);
      });

      ensureCanvasOverlayEnabled();
    }
  };

  // useEffect(() => {
  //   if (getPresetList) {
  //     getPresetList({ type: "branding", status: 1 } as any);
  //   }
  // }, []);
  // Handle logo overlay select
  const handleLogoOverlaySelect = (logoOverlayId: string) => {
    setSelectedLogoOverlayId(logoOverlayId);
    setSelectedTextOverlayId(undefined); // Clear text selection when logo is selected

    const selectedOverlay = canvasOverlay.logoOverlays.find(
      (overlay) => overlay.id === logoOverlayId
    );
    if (selectedOverlay) {
      const width = selectedOverlay.size.width || 100;
      const height = selectedOverlay.size.height || 100;
      const calculatedAspectRatio = width / height;
      const storedAspectRatio = (selectedOverlay as any).aspectRatio;
      const aspectRatio =
        storedAspectRatio &&
        isFinite(storedAspectRatio) &&
        storedAspectRatio > 0
          ? storedAspectRatio
          : isFinite(calculatedAspectRatio) && calculatedAspectRatio > 0
            ? calculatedAspectRatio
            : 1.0;

      const newLogoEditingState = {
        isEditing: true,
        logoOverlayId: selectedOverlay.id,
        url: selectedOverlay.url,
        position: selectedOverlay.position,
        size: selectedOverlay.size,
        opacity: selectedOverlay.opacity || 1.0,
        aspectRatio: aspectRatio,
        rotation: selectedOverlay.rotation || 0,
      };

      openModalWithDelay("logo", () => {
        setLogoEditingState(newLogoEditingState);
        setShowLogoModal(true);
      });

      ensureCanvasOverlayEnabled();
    }
  };

  useEffect(() => {
    if (logoEditingState.isEditing && logoEditingState.logoOverlayId) {
      const currentOverlay = canvasOverlay.logoOverlays.find(
        (overlay) => overlay.id === logoEditingState.logoOverlayId
      );
      if (currentOverlay) {
        const hasPositionChanged =
          currentOverlay.position.x !== logoEditingState.position.x ||
          currentOverlay.position.y !== logoEditingState.position.y;

        const hasSizeChanged =
          currentOverlay.size.width !== logoEditingState.size.width ||
          currentOverlay.size.height !== logoEditingState.size.height;
        if (hasPositionChanged || hasSizeChanged) {
          setLogoEditingState((prev) => {
            let newAspectRatio = prev.aspectRatio;
            if (!maintainAspectRatio) {
              const width = currentOverlay.size.width || 100;
              const height = currentOverlay.size.height || 100;
              const calculatedAspectRatio = width / height;
              newAspectRatio =
                isFinite(calculatedAspectRatio) && calculatedAspectRatio > 0
                  ? calculatedAspectRatio
                  : prev.aspectRatio;
            }

            return {
              ...prev,
              position: currentOverlay.position,
              size: currentOverlay.size,
              aspectRatio: maintainAspectRatio
                ? prev.aspectRatio
                : (currentOverlay as any).aspectRatio &&
                    isFinite((currentOverlay as any).aspectRatio) &&
                    (currentOverlay as any).aspectRatio > 0
                  ? (currentOverlay as any).aspectRatio
                  : newAspectRatio,
            };
          });
        }
      }
    }
  }, [
    canvasOverlay.logoOverlays,
    logoEditingState.isEditing,
    logoEditingState.logoOverlayId,
    logoEditingState.position.x,
    logoEditingState.position.y,
    logoEditingState.size.width,
    logoEditingState.size.height,
    maintainAspectRatio,
  ]);

  // Handle text edit cancel
  const handleTextEditCancel = () => {
    setTextEditingState(resetTextEditingState());
    setShowTextModal(false);
  };

  // Handle text overlay remove
  const handleTextOverlayRemove = () => {
    if (textEditingState.textOverlayId) {
      const updatedTextOverlays = canvasOverlay.textOverlays.filter(
        (overlay) => overlay.id !== textEditingState.textOverlayId
      );
      handleTextOverlaysChange(updatedTextOverlays);
    }
    setTextEditingState(resetTextEditingState());
    setShowTextModal(false);
  };

  // Handle logo edit cancel
  const handleLogoEditCancel = () => {
    setLogoEditingState(resetLogoEditingState());
    setShowLogoModal(false);
  };

  // Handle logo overlay remove
  const handleLogoOverlayRemove = () => {
    if (logoEditingState.logoOverlayId) {
      const updatedLogoOverlays = canvasOverlay.logoOverlays.filter(
        (overlay) => overlay.id !== logoEditingState.logoOverlayId
      );
      handleLogoOverlaysChange(updatedLogoOverlays);
    }
    setLogoEditingState(resetLogoEditingState());
    setShowLogoModal(false);
  };

  // Handle text edit reset
  const handleTextEditReset = () => {
    const initialFontSize = 24;
    const initialFontColor = "#ffffff";
    const initialBackgroundColor = "#000000";
    const initialFontFamily = "Arial";

    setTextEditingState((prev) => ({
      ...prev,
      fontSize: initialFontSize,
      fontColor: initialFontColor,
      backgroundColor: initialBackgroundColor,
      fontFamily: initialFontFamily,
    }));

    if (textEditingState.textOverlayId) {
      const updatedTextOverlays = canvasOverlay.textOverlays.map((overlay) =>
        overlay.id === textEditingState.textOverlayId
          ? {
              ...overlay,
              fontSize: initialFontSize,
              fontColor: initialFontColor,
              backgroundColor: initialBackgroundColor,
              fontFamily: initialFontFamily,
            }
          : overlay
      );
      handleTextOverlaysChange(updatedTextOverlays);
    }
  };

  // Create text change handler
  const createTextChangeHandler =
    (property: keyof typeof textEditingState) => (value: any) => {
      setTextEditingState((prev) => {
        const updatedState = { ...prev, [property]: value };
        if (updatedState.textOverlayId) {
          const updatedTextOverlays = canvasOverlay.textOverlays.map(
            (overlay) =>
              overlay.id === updatedState.textOverlayId
                ? { ...overlay, [property]: value }
                : overlay
          );
          handleTextOverlaysChange(updatedTextOverlays);
        }
        return updatedState;
      });
    };

  // Handle font family change
  const handleFontFamilyChange = (fontFamilyName: any) => {
    setTextEditingState((prev) => {
      const updatedState = { ...prev, fontFamily: fontFamilyName };
      if (updatedState.textOverlayId) {
        const updatedTextOverlays = canvasOverlay.textOverlays.map((overlay) =>
          overlay.id === updatedState.textOverlayId
            ? { ...overlay, fontFamily: fontFamilyName }
            : overlay
        );
        handleTextOverlaysChange(updatedTextOverlays);
      }
      return updatedState;
    });
  };

  // Create logo change handler
  const createLogoChangeHandler =
    (property: keyof typeof logoEditingState) => (value: any) => {
      setLogoEditingState((prev) => {
        const updatedState = { ...prev, [property]: value };
        if (updatedState.logoOverlayId) {
          const updatedLogoOverlays = canvasOverlay.logoOverlays.map(
            (overlay) =>
              overlay.id === updatedState.logoOverlayId
                ? { ...overlay, [property]: value }
                : overlay
          );
          handleLogoOverlaysChange(updatedLogoOverlays);
        }
        return updatedState;
      });
    };

  // Handle logo size change
  const handleLogoSizeChange = (size: { width: number; height: number }) => {
    setLogoEditingState((prev) => {
      const newAspectRatio = maintainAspectRatio
        ? prev.aspectRatio
        : size.width && size.height
          ? size.width / size.height
          : prev.aspectRatio;

      const updatedState = { ...prev, size, aspectRatio: newAspectRatio };
      if (updatedState.logoOverlayId) {
        const updatedLogoOverlays = canvasOverlay.logoOverlays.map((overlay) =>
          overlay.id === updatedState.logoOverlayId
            ? { ...overlay, size, aspectRatio: newAspectRatio }
            : overlay
        );
        handleLogoOverlaysChange(updatedLogoOverlays);
      }
      return updatedState;
    });
  };

  const handleAspectRatioToggle = (locked: boolean) => {
    setMaintainAspectRatio(locked);
  };

  const handleCloseLogoSliders = () => {
    if (closeLogoSlidersRef.current) {
      closeLogoSlidersRef.current();
    }
  };

  // Get pre-roll slate ID
  const getPreRollSlateId = (): string | undefined => {
    const id = preRollMedia?.label;
    return id;
  };

  // Get post-roll slate ID
  const getPostRollSlateId = (): string | undefined => {
    const id = postRollMedia?.label;
    return id;
  };

  // Handle sequential playback
  const handleSequentialPlayback = (playbackSequence: {
    type: "pre-slate" | "video-segments" | "post-slate";
    slateId?: string;
    segments?: Array<{ start: number; end: number }>;
  }) => {
    // Implement sequential playback logic here
  };

  const handlePreRollChange = (media: any) => {
    setPreRollMedia(media);
    setIsPreEdit(false);
    if (media) {
      const newSlateOverlay = {
        id: media.label,
        url:
          media.image ||
          getThumbnailUrlUtil({
            media,
            id: media?.images?.thumb,
            source: media?.source,
          }),
        position: { x: 50, y: 50 },
        size: { width: 200, height: 200 },
        visible: true,
        isSlate: true,
        duration: media.duration || media.meta?.duration || 5,
        autoHide: true,
        isPreRoll: true,
        title: media.value || "Pre-Roll Slate",
      };

      // Remove existing pre-roll slate if any
      const updatedSlateOverlays = canvasOverlay.slateOverlays.filter(
        (slate) => !slate.isPreRoll
      );
      setCanvasOverlay((prev) => ({
        ...prev,
        slateOverlays: [...updatedSlateOverlays, newSlateOverlay],
      }));
      trackEvent("browse", {
        category: "trimmer",
        entity: "pre slate",
        action: "apply",
        location: trimmerLocation,
        ...getTrackUserContext(),
      });
    } else {
      // Remove pre-roll slate
      const updatedSlateOverlays = canvasOverlay.slateOverlays.filter(
        (slate) => !slate.isPreRoll
      );
      setCanvasOverlay((prev) => ({
        ...prev,
        slateOverlays: updatedSlateOverlays,
      }));
    }
  };

  // Handle post-roll change
  const handlePostRollChange = (media: any) => {
    setPostRollMedia(media);
    setIsPostEdit(false);
    if (media) {
      // Convert selected media to slate overlay
      const newSlateOverlay = {
        id: media.label,
        url:
          media.image ||
          getThumbnailUrlUtil({
            media,
            id: media?.images?.thumb,
            source: media?.source,
          }),
        position: { x: 50, y: 50 },
        size: { width: 200, height: 200 },
        visible: true,
        isSlate: true,
        duration: media.duration || media.meta?.duration || 5,
        autoHide: true,
        isPostRoll: true,
        title: media.value || "Post-Roll Slate",
      };

      // Remove existing post-roll slate if any
      const updatedSlateOverlays = canvasOverlay.slateOverlays.filter(
        (slate) => !slate.isPostRoll
      );
      setCanvasOverlay((prev) => ({
        ...prev,
        slateOverlays: [...updatedSlateOverlays, newSlateOverlay],
      }));
      trackEvent("browse", {
        category: "trimmer",
        entity: "post slate",
        action: "apply",
        location: trimmerLocation,
        ...getTrackUserContext(),
      });
    } else {
      // Remove post-roll slate
      const updatedSlateOverlays = canvasOverlay.slateOverlays.filter(
        (slate) => !slate.isPostRoll
      );
      setCanvasOverlay((prev) => ({
        ...prev,
        slateOverlays: updatedSlateOverlays,
      }));
    }
  };

  const handlePreRollSearch = (params: { stitle: string; key: string }) => {
    if (getSearchedListMedia) {
      const searchParams = {
        stitle: params.stitle,
        asset_type: "slates",
        key: "pre",
        orientation: media?.orientation,
        is_foreign_keys: false,
      };
      getSearchedListMedia(searchParams);
    }
  };

  const handlePostRollSearch = (params: { stitle: string; key: string }) => {
    if (getSearchedListMedia) {
      const searchParams = {
        stitle: params.stitle,
        asset_type: "slates",
        key: "post",
        orientation: media?.orientation,
        is_foreign_keys: false,
      };
      getSearchedListMedia(searchParams);
    }
  };

  // Reusable functions for modal management
  const resetTextEditingState = () => ({
    isEditing: false,
    textOverlayId: undefined,
    text: "",
    fontSize: 24,
    fontColor: "#ffffff",
    backgroundColor: "#000000",
    position: { x: 0, y: 0 },
    isBold: false,
    isItalic: false,
    isUnderline: false,
    padding: 0,
    rotation: 0,
    opacity: 1.0,
    fontFamily: "Arial",
  });
  const resetLogoEditingState = () => ({
    isEditing: false,
    logoOverlayId: undefined,
    url: "",
    position: { x: 0, y: 0 },
    size: { width: 200, height: 200 },
    opacity: 1.0,
    aspectRatio: 1.0,
    rotation: 0,
  });

  const closeAllModals = () => {
    setShowTextModal(false);
    setShowLogoModal(false);
    setTextEditingState(resetTextEditingState());
    setLogoEditingState(resetLogoEditingState());
  };

  const ensureCanvasOverlayEnabled = () => {
    if (!canvasOverlay.showCanvasOverlay) {
      setCanvasOverlay((prev) => ({
        ...prev,
        showCanvasOverlay: true,
      }));
    }
  };

  const openModalWithDelay = (
    modalType: "text" | "logo",
    callback: () => void
  ) => {
    closeAllModals();
    setTimeout(() => {
      callback();
    }, 100);
  };

  // Videos array for player
  const videos = [
    {
      id: media?.id || "1",
      title: media?.title || "Current Video",
      duration: media?.meta?.duration || 0,
    },
  ];

  useEffect(() => {
    if (presetId && presetList) {
      const preset = presetList.find((preset) => preset.id === presetId);

      setPresetInfo(preset);
    }
  }, [presetId, presetList]);

  // if (!isOpen) {
  //   return null;
  // }
  // if (duration <= 0 && (!media?.meta?.duration || media.meta.duration <= 0)) {
  //   return null;
  // }

  const Content = (
    <>
      {/* {isPreset && !isPreview && <PresetHeaderForm />} */}
      <div className="row" onClick={(e) => e.stopPropagation()}>
        <div
          className={`${
            readOnlyMode ? "col-12" : "col-lg-8 col-md-7"
          } col-sm-12 trimmer`}
        >
          {/* Combined Modal Rendering - Both text and logo modals appear at the same position */}
          {showTextModal || showLogoModal ? (
            <div className="bg-light border-end ">
              {showTextModal && !readOnlyMode && (
                <OverlayEditingModal
                  showModal={showTextModal}
                  editingType="text"
                  textEditingState={textEditingState}
                  disableClickOutside={true}
                  onTextChange={createTextChangeHandler("text")}
                  onFontSizeChange={createTextChangeHandler("fontSize")}
                  onFontColorChange={createTextChangeHandler("fontColor")}
                  onBackgroundColorChange={createTextChangeHandler(
                    "backgroundColor"
                  )}
                  onFontFamilyChange={handleFontFamilyChange}
                  onBoldChange={createTextChangeHandler("isBold")}
                  onItalicChange={createTextChangeHandler("isItalic")}
                  onUnderlineChange={createTextChangeHandler("isUnderline")}
                  onPaddingChange={createTextChangeHandler("padding")}
                  onOpacityChange={createTextChangeHandler("opacity")}
                  onRotationChange={createTextChangeHandler("rotation")}
                  onReset={handleTextEditReset}
                  onCancel={handleTextEditCancel}
                  onRemove={handleTextOverlayRemove}
                  onCloseSliders={closeLogoSlidersRef}
                />
              )}
              {showLogoModal && !readOnlyMode && (
                <OverlayEditingModal
                  showModal={showLogoModal}
                  editingType="logo"
                  logoEditingState={logoEditingState}
                  videoDimensions={videoDims}
                  maintainAspectRatio={maintainAspectRatio}
                  disableClickOutside={true}
                  onPositionChange={createLogoChangeHandler("position")}
                  onSizeChange={handleLogoSizeChange}
                  onOpacityChange={createLogoChangeHandler("opacity")}
                  onRotationChange={createLogoChangeHandler("rotation")}
                  onAspectRatioToggle={handleAspectRatioToggle}
                  onCancel={handleLogoEditCancel}
                  onRemove={handleLogoOverlayRemove}
                  onCloseSliders={closeLogoSlidersRef}
                />
              )}
            </div>
          ) : !readOnlyMode ? (
            isChopperFlow ? (
              <div className="bg-light ps-3 py-2">
                <span>Select Element to edit</span>
                <small className="text-secondary d-block">
                  <i>
                    Video may appear lower in quality in preview mode, but the
                    trimmed video will retain its original resolution.
                  </i>
                </small>
              </div>
            ) : (
              <div
                className="bg-light text-center pt-3"
                style={{ height: "38px" }}
              >
                Select Element to edit
              </div>
            )
          ) : null}

          {(() => {
            return (
              <GeneralPlayer
                key={playerKey}
                id={media.id}
                videoUrl={
                  currentTab === DRIVE_TAB
                    ? media?.localpreviewfile || media?.previewfile
                    : undefined
                }
                startTrim={startTrim}
                remoteConfig={currentTab === DRIVE_TAB ? true : false}
                endTrim={endTrim}
                onTrimChange={handleStartEndTrimChange}
                onTimeUpdate={handleTimeUpdate}
                showTrimmer={true}
                videos={videos}
                onSegmentsChange={handleSegmentsChange}
                allowMultipleSegments={true}
                autoPlay={3}
                showCanvasOverlay={canvasOverlay.showCanvasOverlay}
                textOverlays={canvasOverlay.textOverlays}
                logoOverlays={canvasOverlay.logoOverlays}
                slateOverlays={canvasOverlay.slateOverlays}
                onOverlayChange={handleCanvasOverlayChange}
                onTextOverlaySelect={handleTextOverlaySelect}
                onLogoOverlaySelect={handleLogoOverlaySelect}
                selectedTextOverlayId={selectedTextOverlayId}
                selectedLogoOverlayId={selectedLogoOverlayId}
                onCloseLogoSliders={handleCloseLogoSliders}
                externalShowTextModal={showTextModal}
                externalShowLogoModal={showLogoModal}
                externalTextEditingState={textEditingState}
                externalLogoEditingState={logoEditingState}
                onHighResCapture={handleHighResCapture}
                videoDimensions={videoDims}
                onSequentialPlayback={handleSequentialPlayback}
                preRollSlateId={getPreRollSlateId()}
                postRollSlateId={getPostRollSlateId()}
                maintainAspectRatio={maintainAspectRatio}
                duration={duration}
                canvasOverlay={canvasOverlay}
                preRollMedia={preRollMedia}
                postRollMedia={postRollMedia}
                getTotalDuration={getTotalDuration}
                isPreset={isPreset}
                onReset={handleReset}
                readOnlyMode={readOnlyMode}
              />
            );
          })()}
        </div>

        {!readOnlyMode && (
          <div
            className="col-lg-4 col-md-5 col-sm-12"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex flex-column gap-3">
              <div onClick={(e) => e.stopPropagation()}>
                <CanvasOverlayControls
                  textOverlays={canvasOverlay.textOverlays}
                  logoOverlays={canvasOverlay.logoOverlays}
                  slateOverlays={canvasOverlay.slateOverlays}
                  onTextOverlaysChange={handleTextOverlaysChange}
                  onLogoOverlaysChange={handleLogoOverlaysChange}
                  onSlateOverlaysChange={handleSlateOverlaysChange}
                  onLogoUpload={handleLogoUpload}
                  showCanvasOverlay={canvasOverlay.showCanvasOverlay}
                  onToggleCanvasOverlay={handleCanvasToggle}
                  selectedTextOverlayId={selectedTextOverlayId}
                  selectedLogoOverlayId={selectedLogoOverlayId}
                  onTextOverlaySelect={handleTextOverlaySelect}
                  onLogoOverlaySelect={handleLogoOverlaySelect}
                  isPrePostRollMode={true}
                  onPreRollChange={handlePreRollChange}
                  onPostRollChange={handlePostRollChange}
                  preRollMedia={preRollMedia}
                  postRollMedia={postRollMedia}
                  preRollMediaList={localPreMediaList}
                  postRollMediaList={localPostMediaList}
                  onPreRollSearch={handlePreRollSearch}
                  onPostRollSearch={handlePostRollSearch}
                  onClearPreRollMedia={() => setLocalPreMediaList([])}
                  onClearPostRollMedia={() => setLocalPostMediaList([])}
                  handlePresetId={handlePresetId}
                  presetList={presetList}
                  callRegisterMediaOnCms={callRegisterMediaOnCms}
                  isPreset={isPreset}
                  ImageUpload={ImageUpload}
                  currentMedia={currentMedia}
                  isPreview={isPreview}
                  readOnlyMode={readOnlyMode}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );

  return isShowModal ? (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setPresetId(null);
      }}
      title={`Trim Video - ${media?.title || "Untitled"}`}
      width="1000px"
      height="auto"
      closeOnOutsideClick={false}
      updateModal={updateModal}
      footer={
        <div className="d-flex justify-content-between align-items-center w-100">
          <span className="d-flex align-items-center text-muted">
            Duration: {secondsToHms(totalDuration)}
          </span>
          <div className="d-flex gap-2">
            {!isPreset && (
              <Button
                className="H"
                type="outline-primary"
                onClick={() => {
                  handleReset();
                  setPresetId(null);
                  onClose();
                }}
              >
                Cancel
              </Button>
            )}
            <Button
              type="primary"
              onClick={() => handleTrimComplete(true)}
              isDisabled={isTrimLoading}
            >
              {isTrimLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing...
                </>
              ) : isPreset ? (
                "Create"
              ) : isPreview ? (
                "Close"
              ) : (
                "Apply"
              )}
            </Button>
          </div>
        </div>
      }
    >
      {Content}
    </Modal>
  ) : (
    <>{Content}</>
  );
};

export default VideoTrimmer;
